
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BaseWarning',
  props: {
    position: {
      type: String,
      default: 'vertically',
      validator: (value: string) => ['vertically', 'horizontal'].includes(value)
    },
    name: {
      type: String,
      default: 'alert-triangle',
      validator: (value: string) =>
        ['alert-circle', 'alert-triangle'].includes(value)
    }
  }
})
